import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AppProvider } from "@/context/AppContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Browse from "@/pages/Browse";
import ProductDetail from "@/pages/ProductDetail";
import StoreFront from "@/pages/StoreFront";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Checkout from "@/pages/Checkout";
import Orders from "@/pages/Orders";
import BecomeSeller from "@/pages/BecomeSeller";
import SellerDashboard from "@/pages/SellerDashboard";
import Chat from "@/pages/Chat";
import Payment from "@/pages/Payment";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <AuthProvider>
      <AppProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/belanja" element={<Browse />} />
            <Route path="/produk/:id" element={<ProductDetail />} />
            <Route path="/toko/:slug" element={<StoreFront />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/buka-toko" element={<BecomeSeller />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/pesanan" element={<ProtectedRoute><Orders /></ProtectedRoute>} />
            <Route path="/chat" element={<ProtectedRoute><Chat /></ProtectedRoute>} />
            <Route path="/bayar/:orderId" element={<ProtectedRoute><Payment /></ProtectedRoute>} />
            <Route path="/seller" element={<ProtectedRoute roles={["seller", "admin"]}><SellerDashboard /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AppProvider>
    </AuthProvider>
  );
}

export default App;
